import { useState } from "react";

export const FibCalc = () => {
  const [idade, setIdade] = useState("");
  const [ast, setAst] = useState("");
  const [alt, setAlt] = useState("");
  const [plaquetas, setPlaquetas] = useState("");
  const [resultado, setResultado] = useState(null);

  const calcularFib4 = () => {
    if (!idade || !ast || !alt || !plaquetas) return;

    const fib4 =
      (Number(idade) * Number(ast)) /
      (Number(plaquetas) * Math.sqrt(Number(alt)));

    setResultado(fib4.toFixed(2));
  };

  const interpretarResultado = () => {
    const valor = Number(resultado);
    const idadeNum = Number(idade);

    if (idadeNum <= 65) {
      if (valor <= 1.3) {
        return "Baixa probabilidade de fibrose.";
      }
      return "Valor acima de 1,3. Recomenda-se maior investigação médica.";
    }

    // Para maiores de 65 anos
    if (valor <= 2.0) {
      return "Baixa probabilidade de fibrose.";
    }
    return "Valor acima de 2,0. Recomenda-se maior investigação médica.";
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">

          <h2 className="fib4-text text-center">Calculadora FIB-4</h2>

          <div className="card p-4 shadow-sm">

            <div className="mb-3">
              <label className="form-label">Idade (anos)</label>
              <input
                type="number"
                className="form-control"
                value={idade}
                onChange={(e) => setIdade(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">TGO (U/L)</label>
              <input
                type="number"
                className="form-control"
                value={ast}
                onChange={(e) => setAst(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">TGP (U/L)</label>
              <input
                type="number"
                className="form-control"
                value={alt}
                onChange={(e) => setAlt(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Plaquetas (10⁹/L)</label>
              <input
                type="number"
                className="form-control"
                value={plaquetas}
                onChange={(e) => setPlaquetas(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary w-100"
              onClick={calcularFib4}
            >
              Calcular FIB-4
            </button>

            {resultado && (
              <div className="alert alert-info mt-4 text-center">
                <strong>Resultado:</strong> {resultado}
                <br />
                <span>{interpretarResultado()}</span>
              </div>
            )}

          </div>

          <p className="text-muted text-center mt-3" style={{ fontSize: "0.85rem" }}>
            * Esta calculadora não substitui avaliação médica especializada.
          </p>

        </div>
      </div>
    </div>
  );
};